import USER_TYPES from '@/constants/authorization/user-types'
import TabletGuard from '@/router/guards/tablet-guard'
import { PACKAGE_PERMISSIONS } from '@/constants/features'
import multiGuard from '@/router/utils/vue-router-multiguard'
import PackagePermissionsGuard from '@/router/guards/package-permissions-guard'

export default [
  {
    path: 'customers',
    name: 'admin:customers',
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_SUPERVISOR] },
    component: () => import(/* webpackChunkName: "clients" */ '@/views/admin/marketing/clients/ClientsTable.vue'),
  },
  {
    path: 'queues',
    name: 'admin:queues',
    alias: '/admin/queue',
    beforeEnter: multiGuard([TabletGuard, PackagePermissionsGuard]),
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_SUPERVISOR, USER_TYPES.KITCHEN_WAITER], packagePermissions: [PACKAGE_PERMISSIONS.QUEUE] },

    component: () => import(/* webpackChunkName: "queues" */ '@/views/admin/management/queues/QueuesWizard.vue'),
  },
  {
    path: 'reservations',
    name: 'admin:reservations',
    beforeEnter: multiGuard([PackagePermissionsGuard]),
    meta: { packagePermissions: [PACKAGE_PERMISSIONS.RESERVATION] },
    component: () => import(/* webpackChunkName: "reservations" */ '@/views/admin/management/reservations/ReservationsWizard.vue'),
  },
  {
    path: 'orders',
    name: 'admin:orders',
    alias: '/admin/orders',
    component: () => import(/* webpackChunkName: "reservations" */ '@/views/admin/management/orders/OrdersWizard.vue'),
  },
  {
    path: 'orders/:id/history',
    name: 'admin:orders-histories',
    alias: '/admin/orders/:id/history',
    component: () => import(/* webpackChunkName: "reservations" */ '@/views/admin/management/orders/OrderHistories.vue'),
  },
  {
    path: 'orders/invoice/:id',
    name: 'admin:order-invoice',
    component: () => import(/* webpackChunkName: "reservations" */ '@/views/admin/management/orders/components/OrderInvoice.vue'),
  },
  {
    path: 'transactions',
    name: 'admin:transactions',
    alias: '/admin/transactions',
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_SUPERVISOR] },
    component: () => import(/* webpackChunkName: "reservations" */ '@/views/admin/management/transactions/TransactionsTabs.vue'),
  },
  {
    path: 'order-display-system',
    name: 'admin:kitchen',
    beforeEnter: multiGuard([PackagePermissionsGuard]),
    meta: { packagePermissions: [PACKAGE_PERMISSIONS.KITCHEN] },
    component: () => import(/* webpackChunkName: "kitchen" */ '@/views/admin/management/order-display-system/OrderDisplaySystemWizard.vue'),
  },
  {
    path: 'statistics',
    name: 'admin:statistics',
    beforeEnter: multiGuard([PackagePermissionsGuard]),
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.AUDITOR], packagePermissions: [PACKAGE_PERMISSIONS.STATISTICS] },
    component: () => import(/* webpackChunkName: "statistics" */ '@/views/admin/management/statistics/StatisticsView.vue'),
  },
  {
    path: 'branches-statistics',
    name: 'admin:branches-statistics',
    beforeEnter: multiGuard([PackagePermissionsGuard]),
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.AUDITOR], packagePermissions: [PACKAGE_PERMISSIONS.STATISTICS] },
    component: () => import(/* webpackChunkName: "statistics" */ '@/views/admin/management/statistics/BranchesStatisticsView.vue'),
  },
  {
    path: 'store',
    name: 'admin:store',
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/admin/integration-views/IntegrationsList.vue'),
  },
  {
    path: 'integrations/:id',
    name: 'admin:integrations:view',
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "integrations" */ '@/views/admin/integration-views/IntegrationView.vue'),
  },
  {
    path: 'addons',
    name: 'admin:addons',
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "addons" */ '@/views/admin/addons-views/AddonsList.vue'),
  },
  {
    path: 'addons/:id',
    name: 'admin:addons:view',
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "addons" */ '@/views/admin/addons-views/AddonView.vue'),
  },
]
